// ----------------------------------------------------------------------------
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// ----------------------------------------------------------------------------
/* eslint-disable @typescript-eslint/no-inferrable-types */
// Scope Base of AAD app. Use the below configuration to use all the permissions provided in the AAD app through Azure portal.
// Refer https://aka.ms/PowerBIPermissions for complete list of Power BI scopes
// URL used for initiating authorization request
export const authorityUrl = "https://login.microsoftonline.com/common/";
// End point URL for Power BI API
export const powerBiApiUrl = "https://api.powerbi.com/";
// Scope for securing access token
export const scopeBase = ["https://analysis.windows.net/powerbi/api/Report.Read.All"];
// Client Id (Application Id) of the AAD app.
export const clientId = localStorage.getItem("powerbi_client_id") || "";
// Id of the workspace where the report is hosted
export const workspaceId = localStorage.getItem("powerbi_workspace_id") || "";
// Id of the report to be embedded
export const reportId = localStorage.getItem("powerbi_report_id") || "";
